import React from 'react';
import girl1Img from '../../../images/webp/girl-1.webp';
import girl2Img from '../../../images/webp/girl-2.webp';

const Team = () => {
    return (
        <div style={{ marginTop: -180, padding: 30 }}>
            <div className="row text-center">
                <div className="col-md-6 text-light mt-2">
                    <div data-aos="fade-down" data-aos-duration="2000" style={{ background: '#ff3465', borderRadius: 20 }}>
                        <p >
                            <span style={{ padding: 5, fontWeight: 700, borderBottom: '3px solid white' }}>Dainne Eam</span>
                        </p>
                        <h4 className="fw-bolder">+880 1870 289 584</h4>
                        <h4 className="fw-bolder">mdmehedyh55@gmail.com</h4>
                        <img className="w-100" src={girl1Img} alt="" />
                    </div>
                </div>
                <div className="col-md-6 text-dark mt-2">
                    <div data-aos="fade-down" data-aos-duration="3000" style={{ background: '#ffe9c2', borderRadius: 20 }}>
                        <p>
                            <span style={{ padding: 5, fontWeight: 700, borderBottom: '3px solid #ff3465' }}>Ema Rose</span>
                        </p>
                        <h4 className="fw-bolder">+880 1870 289 584</h4>
                        <h4 className="fw-bolder">mdmehedyh55@gmail.com</h4>
                        <img className="w-100" src={girl2Img} alt="" />
                    </div>

                </div>

            </div>
        </div>
    );
};

export default Team;